import React from "react";

const LinkedSectionContainer = ({ children, navigateToSection }) => {
  if (!children || children.length === 0) {
    return <div>No sections available to display.</div>;
  }

  const activeSection = children[0]; // Always display the first child for simplicity

  return (
    <div className="linked-section-container">
      {React.cloneElement(activeSection, { navigateToSection })}
    </div>
  );
};

export default LinkedSectionContainer;
